// extracted by mini-css-extract-plugin
module.exports = {"container":"ProductCardAttributes_container__oVoqz","details-action":"ProductCardAttributes_details-action__VAL_f"};